<template>
  <div
    class="relative h-full flex flex-col bg-white text-gray-600"
    :class="{ 'lg:border lg:border-gray-200 lg:rounded': isCheckoutType }"
  >
    <WebshopCartHeader
      :title="$t('Loyalty.Webshop.Cart.Title')"
      :type="type"
      :cart="cart"
      @close="$emit('close')"
      @edit="isEditing = !isEditing"
    />
    <p
      v-if="!isCheckoutType"
      class="ota-p16 mt-6 mb-5 pl-5 lg:pl-10 lg:mt-2 lg:mb-10"
      v-html="`${$t('Loyalty.Webshop.Cart.TotalItems')} <span class='ota-p16 font-semibold'>${totalCartItems}</span>`"
    />
    <div
      v-if="totalCartItems"
      class="flex-1 overflow-y-scroll disable-scrollbars"
      :class="{
        'pt-5': isCheckoutType,
        'lg:px-5': !isCheckoutType
      }"
    >
      <div
        v-for="(cartItem, index) in cart"
        :key="`${cartItem.productId}-${index}`"
        class="mb-5"
      >
        <WebshopCartItem
          :cart-item="cartItem"
          :type="type"
          :can-edit="showEditTools"
          @minus="$emit('minus', $event)"
          @plus="$emit('plus', $event)"
          @remove="$emit('remove', $event)"
        />
      </div>
    </div>
    <div
      v-if="totalCartItems"
      class="lg:bg-white"
      :class="{ 'p-5 bg-gray-200 lg:px-10': !isCheckoutType }"
    >
      <WebshopReceipt
        v-bind="receiptProps"
        :type="type"
        :class="{ 'border-gray-200 border rounded': !isCheckoutType }"
      />
      <div v-if="!isCheckoutType" class="pt-5">
        <OButton variant="secondary" class="w-full" @click="$emit(isWalletFrozen ? 'activate' : 'checkout')">
          {{ isWalletFrozen ? $t('Loyalty.Webshop.ProductDetail.FirstActivateMembership') : $t('Loyalty.Webshop.Cart.GoToCheckout') }}
        </OButton>
      </div>
    </div>
    <div v-else class="text-gray-200 text-center flex flex-col items-center my-10">
      <OSvg svg="cart" class="w-20 mb-5 fill-gray-200 text-gray-200" />
      <p class="ota-p16 font-extrabold" v-text="$t('Loyalty.Webshop.Cart.EmptyCart')" />
      <slot />
    </div>
  </div>
</template>

<script>
import WebshopCartHeader from '@/components/Webshop/WebshopCart/WebshopCartHeader'
import WebshopCartItem from '@/components/Webshop/WebshopCart/WebshopCartItem'
import WebshopReceipt from '@/components/Webshop/WebshopReceipt'
import OButton from '@/components/OButton'
import OSvg from '@/components/OSvg'
import { CartTypes } from '@/enums/webshop'

export default {
  name: 'WebshopCart',
  components: { WebshopCartHeader, WebshopReceipt, OButton, OSvg, WebshopCartItem },
  props: {
    cart: {
      type: Array,
      default: () => ([])
    },
    isWalletFrozen: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: CartTypes.Cart,
      validator: value => Object.keys(CartTypes).includes(value)
    },
    receiptProps: {
      type: Object,
      default: () => ({})
    },
    country: {
      type: String,
      default: 'nl'
    },
    totalCartItems: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      isEditing: false
    }
  },
  computed: {
    isCheckoutType () {
      return this.type === CartTypes.Checkout
    },
    showEditTools () {
      return !this.isCheckoutType || this.isEditing
    }
  }
}
</script>

<style lang="postcss" scoped>
.disable-scrollbars {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* IE 10+ */

  &::-webkit-scrollbar {
    display: none; /* Chrome/Safari/Webkit */
  }
}
</style>
